import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ReviewRmsPlanScheduleComponent } from '../../../../components/review-content/review-rms-plan-schedule/review-rms-plan-schedule.component';

@Component({
  selector: 'rms-schedule-submission',
  standalone: true,
  imports: [
    CommonModule,
    ReviewRmsPlanScheduleComponent
  ],
  templateUrl: './rms-schedule-submission.component.html',
  styleUrl: './rms-schedule-submission.component.css'
})
export class RmsScheduleSubmissionComponent implements OnInit {

  @Input() rmsPlanReviewScheduleData: any;
  @Output() onSaveSection3 = new EventEmitter<any>();

  currentCaseId: string | null = null;

  ngOnInit(): void {
    if (this.rmsPlanReviewScheduleData) {
      this.currentCaseId = this.rmsPlanReviewScheduleData.case_id;
    }
  }

  submitRmsPlanReviewSchedule(): void {
    this.onSaveSection3.emit({});
  }


}
